import axios from "axios";
import React, { useEffect, useState } from "react";
import DonutGraph from "../../Graphs/DonutGraph";
import { DASHBOARD_EQUITY } from "../../../Configuration/API_URL";
import Loader from "../../Common/Loader";
import { Constants } from "../../../CommonMethhods/Constants";
import {
  AESEncryption,
  ApiResDecrypt,
} from "../../../CommonMethhods/CommonMethods";

export default function ClientStatusGraph() {
  const storeToken = localStorage.getItem("ssoToken");

  const [clientDetail, setClientDetail] = useState();
  const [loader, setLoader] = useState(true);

  let active, inActive, closed, dormantDeactive;

  const getClientGraphDetail = async () => {
    let payloadValue = {};
    let encPayload = AESEncryption(payloadValue);
    try {
      const getClientDetail = await axios.post(
        DASHBOARD_EQUITY.EquityClientStatusGraph_URL,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getClientDetail?.data);

      setClientDetail(res?.data);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };
  useEffect(() => {
    getClientGraphDetail();
  }, [active, inActive, closed, dormantDeactive]);

  active =
    clientDetail === undefined || null
      ? 0
      : clientDetail.active === undefined || null
      ? 0
      : clientDetail.active;

  inActive =
    clientDetail === undefined || null
      ? 0
      : clientDetail.inactive === undefined || null
      ? 0
      : clientDetail.inactive;

  dormantDeactive =
    clientDetail === undefined || null
      ? 0
      : clientDetail.dormantClient === undefined || null
      ? 0
      : clientDetail.dormantClient;

  closed =
    clientDetail === undefined || null
      ? 0
      : clientDetail.closed === undefined || null
      ? 0
      : clientDetail.closed;

  const calcPercentage = (value) => {
    let total =
      Number(active) +
      Number(inActive) +
      Number(closed) +
      Number(dormantDeactive);
    value = Number(value);

    const percentage = (value / total) * 100;
    if (percentage > 0) {
      return percentage;
    } else {
      return 0;
    }
  };

  return (
    <div className="card-box">
      <div className="card-title">
        <h2 className="mb-0">{Constants.ClientStatus}</h2>
        {!loader && (
          <p className="client-status-value mb-0">
            {clientDetail?.total ? clientDetail.total : 0}
          </p>
        )}
      </div>
      {loader ? (
        <div className="loader-alignment">
          <Loader />
        </div>
      ) : (
        <div className="card-inner client-status-box">
          <div className="card-inner-left">
            <div className="d-flex align-items-end client-status-active">
              <div className="client-active-left">
                <p className="client-status-label">{Constants.Active}</p>
                <span className="label-value">{active}</span>
              </div>
              <div className="client-active-right">
                <label htmlFor="">
                  <span className="client-status-percentage-dot active-dot" />
                  {calcPercentage(active).toFixed(1)}%
                </label>
              </div>
            </div>
            <div className="client-status-active">
              <div className="client-active-left">
                <p className="client-status-label">{Constants.Inactive}</p>
                <span className="label-value">{inActive}</span>
              </div>
              <div className="client-active-right">
                <label htmlFor="">
                  <span className="client-status-percentage-dot inactive-dot" />
                  {calcPercentage(inActive).toFixed(1)}%
                </label>
              </div>
            </div>
            <div className="client-status-active">
              <div className="client-active-left">
                <p className="client-status-label">Dormant</p>
                <span className="label-value">{dormantDeactive}</span>
              </div>
              <div className="client-active-right">
                <label htmlFor="">
                  <span className="client-status-percentage-dot dormant-deactive" />
                  {calcPercentage(dormantDeactive).toFixed(1)}%
                </label>
              </div>
            </div>
            <div className="d-flex align-items-end client-status-active mb-0">
              <div className="client-active-left">
                <p className="client-status-label">Closed</p>
                <span className="label-value">{closed}</span>
              </div>
              <div className="client-active-right">
                <label htmlFor="">
                  <span className="client-status-percentage-dot" />
                  {calcPercentage(closed).toFixed(1)}%
                </label>
              </div>
            </div>
          </div>
          <div className="circle">
            <DonutGraph
              graphActive={Number(active)}
              graphInactive={Number(inActive)}
              graphClosed={Number(closed)}
              graphDormantDeactive={Number(dormantDeactive)}
              titles={[
                "Client Status",
                "Active",
                "Inactive",
                "Closed",
                "Dormant_Deactive",
              ]}
              colors={[
                "rgb(254, 218, 124)",
                "rgba(255, 134, 177)",
                "rgba(97, 207, 242)",
                "rgb(13, 191, 141)",
              ]}
            />
          </div>
        </div>
      )}
    </div>
  );
}
